'use strict';

angular.module('dekky.forms')
	.directive('formRow', function($q, $http, $templateCache, $compile) {
		return {
			restrict: 'AE',
			require: 'ngModel',
			replace: true,
			scope: {
				field: '=',
				model: '=ngModel',
				fieldIndex: '=',
                disabled: '=?ngDisabled'
			},
			link: function(scope, element, attr) {
				var theme = scope.field.form.config.theme,
					template = attr.templateUrl ? attr.templateUrl :  theme + '/row.html';

				function getTemplateUrl() {
					return $q.when(template);
				}

				function loadTemplate(template) {
					return $http.get(template, {cache: $templateCache})
							.then(function(response) {
								return angular.element(response.data);
							});
				}

				function compileTemplate(template) {
					element.append(template);

					return $compile(element.contents())(scope);
				}

				getTemplateUrl()
					.then(loadTemplate)
					.then(compileTemplate);
			}
		}
	});